(() => {
  const setRequired = (container, required) => {
    container.querySelectorAll('[data-guardian-required]').forEach((field) => {
      field.required = required;
      field.disabled = !required;
    });
  };

  document.querySelectorAll('#StudentAffiliateApplication').forEach((form) => {
    const ageRange = form.querySelector('[data-age-range]');
    const guardianFields = form.querySelector('[data-guardian-fields]');
    const applicationFields = form.querySelector('[data-application-fields]');
    const ageMessage = form.querySelector('[data-age-message]');
    const ageGroup = form.querySelector('[data-age-group]');
    const submitButton = form.querySelector('button[type="submit"]');
    if (!ageRange || !guardianFields || !applicationFields || !ageMessage || !ageGroup || !submitButton) return;

    const updateAgeState = () => {
      const selection = ageRange.value;
      ageMessage.classList.remove('is-visible', 'is-ok');
      applicationFields.hidden = true;
      guardianFields.hidden = true;
      setRequired(guardianFields, false);
      submitButton.disabled = false;
      ageGroup.value = '';

      if (!selection) return '';

      ageMessage.classList.add('is-visible');
      if (selection === 'Under 14') {
        ageMessage.textContent = 'This program is currently available only to students age 14 or older. No application information will be submitted.';
        submitButton.disabled = true;
        ageGroup.value = 'Under 14 — not eligible';
      } else if (selection === '14–15' || selection === '16–17') {
        ageMessage.textContent = 'A parent or legal guardian must approve your application and complete the separate parent-consent form before you can join.';
        ageMessage.classList.add('is-ok');
        applicationFields.hidden = false;
        guardianFields.hidden = false;
        setRequired(guardianFields, true);
        ageGroup.value = 'Age 14–17 — guardian consent required';
      } else {
        ageMessage.textContent = 'You meet the program’s age requirement and may complete the application yourself.';
        ageMessage.classList.add('is-ok');
        applicationFields.hidden = false;
        ageGroup.value = 'Age 18 or older';
      }
      return selection;
    };

    ageRange.addEventListener('change', updateAgeState);
    form.addEventListener('submit', (event) => {
      const selection = updateAgeState();
      if (!selection || selection === 'Under 14') {
        event.preventDefault();
        ageRange.focus();
      }
    });
    updateAgeState();
  });
})();
